export const calculateRate = (categoryCount, totalCount) => {
  if (!totalCount) return 0;
  return ((categoryCount / totalCount) * 100)?.toFixed(2);
};
